<script>
import { useReservationStore } from '../../../store/contact/ReservationStore';

export default {
    setup() {
        const store = useReservationStore();
        const { nextStep, prevStep, currentStep, totalSteps } = store;
        return {
            nextStep,
            prevStep,
            currentStep,
            totalSteps,
        };
    },
};
</script>
<template>
    <div
        class="tw-flex tw-w-full tw-flex-col-reverse tw-items-center lg:tw-flex-row"
    >
        <div class="back-button-wrapper mt-40px mt-0px-lg lg:tw-w-1/2">
            <a
                href="/contact-us"
                class="fs-14px fw-semibold tw-text-accentGreen hover:tw-text-accentGreen"
            >
                BACK TO START
            </a>
        </div>

        <div class="buttons-wrapper lg:tw-w-1/2">
            <div class="prev-button tw-w-[88px]" @click="prevStep">
                <i aria-hidden="true" class="fa fa-chevron-left fw-bold"></i>
            </div>
            <div
                class="tw-cursor-pointer tw-uppercase tw-bg-accentGreen tw-text-white tw-text-[14px] tw-w-[284px] tw-text-center tw-tracking-[2px] tw-flex tw-items-center tw-justify-center"
                @click="nextStep"
                v-if="currentStep == totalSteps"
            >
                PROCEED TO PAYMENT
                <i aria-hidden="true" class="fa fa-chevron-right fw-bold"></i>
            </div>
        </div>
    </div>
</template>
